import React from 'react';
import {BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Inicio from './Components/Inicio'; 
import Login from './Components/Login/Login'; 
import Registrar from './Components/Registrar/Registrar'; 
import Recuperar from './Components/RecuperarClave/Recuperar'; 
import CredencialesState from './Context/CredencialesContext/CredencialesState';
import Prestador from './Components/ApiPrestador/Prestador'; 
import PrestadorState from './Context/PrestadorContext/PrestadorState';
import Modificar from './Components/ModificarClave/Modificar'; 

function App() {
  
  // const path = window.location.pathname;
  
  //DETECTAR INACTIVIDAD CADA 3 HORAS
  // var activo = false;
  // document.onmousemove = function(){
  //       activo = true;
  // };
  // setInterval (function() {
  //   if(!activo ){
  //       localStorage.clear()
  //       window.location.replace('/login');
  //   }else{
  //       activo = false;
  //   }
  // }, 10800000);

  return (
    <>
      <CredencialesState>
        <PrestadorState>
          <Router>
            <Switch>
                <Route exact path='/' component={Inicio}/>
                <Route exact path='/login' component={Login}/>
                <Route exact path='/registrar' component={Registrar}/>
                <Route exact path='/recuperar' component={Recuperar}/>
                <Route exact path='/prestadores' component={Prestador}/>
                <Route exact path='/modificar' component={Modificar}/>
            </Switch>
          </Router>
        </PrestadorState>
      </CredencialesState>
    </>
  );
}

export default App;
